export default __webpack_public_path__ + "static/media/ProPolisLogo.a972fc9e.png";